export const countries = [
  {
    label: "Argentina",
    code: '009',
    flag: (
      <div className="bg-[url('@/assets/images/Argentina.8a7ee59e.svg')] w-[24px] h-[24px] rounded-[50%] bg-contain"></div>
    )
  },
  {
    label: "Australia",
    code: '004',
    flag: (
      <div className="bg-[url('@/assets/images/Australia.svg')] w-[24px] h-[24px] rounded-[50%] bg-contain"></div>
    )
  },
  {
    label: "Austria",
    code: '073',
    flag: (
      <div className="bg-[url('@/assets/images/Austria.svg')] w-[24px] h-[24px] rounded-[50%] bg-contain"></div>
    )
  },
 {
    label: "Belgium",
    code: '034',
    flag: (
      <div className="bg-[url('@/assets/images/Belgium.svg')] w-[24px] h-[24px] rounded-[50%] bg-contain"></div>
    )
  },
  {
    label: "Brazil",
    code: '023',
    flag: (
      <div className="bg-[url('@/assets/images/Brazil.5352629c.svg')] w-[24px] h-[24px] rounded-[50%] bg-contain"></div>
    )
  },
  {
    label: "Brunei Darussalam",
    code: '109',
    flag: (
    <div className="bg-[url('@/assets/images/Brunei_Darussalam.72905153.svg')] w-[24px] h-[24px] rounded-[50%] bg-contain"></div>
    )
  },
  {
    label: "Canada",
    code: '005',
    flag: (
    <div className="bg-[url('@/assets/images/Canada.svg')] w-[24px] h-[24px] rounded-[50%] bg-contain"></div>
    )
  },
  {
    label: "Chile",
    code: '028',
    flag: (
    <div className="bg-[url('@/assets/images/Chile.svg')] w-[24px] h-[24px] rounded-[50%] bg-contain"></div>
    )
  },
  {
    label: "China",
    code: '231',
    flag: (
    <div className="bg-[url('@/assets/images/China.svg')] w-[24px] h-[24px] rounded-[50%] bg-contain"></div>
    )
  },
  {
    label: "Denmark",
    code: '047',
    flag: (
    <div className="bg-[url('@/assets/images/Denmark.svg')] w-[24px] h-[24px] rounded-[50%] bg-contain"></div>
    )
  },
  {
    label: "Finland",
    code: '036',
    flag: (
    <div className="bg-[url('@/assets/images/Finland.svg')] w-[24px] h-[24px] rounded-[50%] bg-contain"></div>
    )
  },
  {
    label: "France",
    code: '017',
    flag: (
    <div className="bg-[url('@/assets/images/France.svg')] w-[24px] h-[24px] rounded-[50%] bg-contain"></div>
    )
  },
  {
    label: "Germany",
    code: '006',
    flag: (
    <div className="bg-[url('@/assets/images/Germany.svg')] w-[24px] h-[24px] rounded-[50%] bg-contain"></div>
    )
  },
  {
    label: "Greece",
    code: '015',
    flag: (
    <div className="bg-[url('@/assets/images/Greece.svg')] w-[24px] h-[24px] rounded-[50%] bg-contain"></div>
    )
  },
  {
    label: "Hong Kong",
    code: '810000',
    flag: (
    <div className="bg-[url('@/assets/images/HongKong.svg')] w-[24px] h-[24px] rounded-[50%] bg-contain"></div>
    )
  },
  {
    label: "Iceland",
    code: '089',
    flag: (
    <div className="bg-[url('@/assets/images/Iceland.svg')] w-[24px] h-[24px] rounded-[50%] bg-contain"></div>
    )
  },
  {
    label: "India",
    code: '022',
    flag: (
    <div className="bg-[url('@/assets/images/India.72ba6cd7.svg')] w-[24px] h-[24px] rounded-[50%] bg-contain"></div>
    )
  },
  {
    label: "Indonesia",
    code: '037',
    flag: (
    <div className="bg-[url('@/assets/images/Indonesia.svg')] w-[24px] h-[24px] rounded-[50%] bg-contain"></div>
    )
  },
  {
    label: "Israel",
    code: '007',
    flag: (
    <div className="bg-[url('@/assets/images/Israel.svg')] w-[24px] h-[24px] rounded-[50%] bg-contain"></div>
    )
  },
  {
    label: "Italy",
    code: '019',
    flag: (
    <div className="bg-[url('@/assets/images/Italy.svg')] w-[24px] h-[24px] rounded-[50%] bg-contain"></div>
    )
  },
  {
    label: "Japan",
    code: '021',
    flag: (
    <div className="bg-[url('@/assets/images/Japan.svg')] w-[24px] h-[24px] rounded-[50%] bg-contain"></div>
    )
  },
  {
    label: "Kazakhstan",
    code: '027',
    flag: (
    <div className="bg-[url('@/assets/images/Kazakhstan.f9a2b67c.svg')] w-[24px] h-[24px] rounded-[50%] bg-contain"></div>
    )
  },
  {
    label: "Kuwait",
    code: '070',
    flag: (
    <div className="bg-[url('@/assets/images/Kuwait.svg')] w-[24px] h-[24px] rounded-[50%] bg-contain"></div>
    )
  },
  {
      label: "Kyrgyzstan",
      code: '100',
      flag: (
      <div className="bg-[url('@/assets/images/Kyrgyzstan.b6299be0.svg')] w-[24px] h-[24px] rounded-[50%] bg-contain"></div>
      )
  },
  {
      label: "Laos",
      code: '102',
      flag: (
      <div className="bg-[url('@/assets/images/Laos.svg')] w-[24px] h-[24px] rounded-[50%] bg-contain"></div>
      )
  },
  {
      label: "Liechtenstein",
      code: '150',
      flag: (
      <div className="bg-[url('@/assets/images/Liechtenstein.f26d87e2.svg')] w-[24px] h-[24px] rounded-[50%] bg-contain"></div>
      )
  },
  {
      label: "Lithuania",
      code: '072',
      flag: (
      <div className="bg-[url('@/assets/images/Lithuania.svg')] w-[24px] h-[24px] rounded-[50%] bg-contain"></div>
      )
  },
  {
      label: "Luxembourg",
      code: '003',
      flag: (
      <div className="bg-[url('@/assets/images/Luxembourg.svg')] w-[24px] h-[24px] rounded-[50%] bg-contain"></div>
      )
  },
  {
      label: "Macao",
      code: '820000',
      flag: (
      <div className="bg-[url('@/assets/images/Macao.svg')] w-[24px] h-[24px] rounded-[50%] bg-contain"></div>
      )
  },
  {
      label: "Malaysia",
      code: '066',
      flag: (
      <div className="bg-[url('@/assets/images/Malaysia.svg')] w-[24px] h-[24px] rounded-[50%] bg-contain"></div>
      )
  },
  {
      label: "Monaco",
      code: '044',
      flag: (
      <div className="bg-[url('@/assets/images/Monaco.svg')] w-[24px] h-[24px] rounded-[50%] bg-contain"></div>
      )
  },
  {
      label: "Netherlands",
      code: '002',
      flag: (
      <div className="bg-[url('@/assets/images/Netherlands.svg')] w-[24px] h-[24px] rounded-[50%] bg-contain"></div>
      )
  },
  {
      label: "New Zealand",
      code: '042',
      flag: (
          <div className="bg-[url('@/assets/images/New_Zealang.4505a733.svg')] w-[24px] h-[24px] rounded-[50%] bg-contain"></div>
          
      )
  },
  {
      label: "Norway",
      code: '039',
      flag: (
          <div className="bg-[url('@/assets/images/Norway.svg')] w-[24px] h-[24px] rounded-[50%] bg-contain"></div>
          
      )
  },
  {
      label: "Philippines",
      code: '049',
      flag: (
          <div className="bg-[url('@/assets/images/Philippines.0a9c45de.svg')] w-[24px] h-[24px] rounded-[50%] bg-contain"></div>
          
      )
  },
  {
      label: "Poland",
      code: '090',
      flag: (
          <div className="bg-[url('@/assets/images/Poland.svg')] w-[24px] h-[24px] rounded-[50%] bg-contain"></div>
          
      )
  },
  {
      label: "Portugal",
      code: '048',
      flag: (
          <div className="bg-[url('@/assets/images/Portugal.f2028167.svg')] w-[24px] h-[24px] rounded-[50%] bg-contain"></div>
          
      )
  },
  {
      label: "Qatar",
      code: '071',
      flag: (
          <div className="bg-[url('@/assets/images/Qatar.svg')] w-[24px] h-[24px] rounded-[50%] bg-contain"></div>
          
      )
  },
  {
      label: "Russia",
      code: '035',
      flag: (
          <div className="bg-[url('@/assets/images/Russia.svg')] w-[24px] h-[24px] rounded-[50%] bg-contain"></div>
          
      )
  },
  {
      label: "Saudi Arabia",
      code: '106',
      flag: (
      <div className="bg-[url('@/assets/images/Saudi_Arabia.eece8894.svg')] w-[24px] h-[24px] rounded-[50%] bg-contain"></div>
      )
  },
  {
      label: "Singapore",
      code: '011',
      flag: (
      <div className="bg-[url('@/assets/images/Singapore.svg')] w-[24px] h-[24px] rounded-[50%] bg-contain"></div>
      )
  },
  {
      label: "South Africa",
      code: '016',
      flag: (
      <div className="bg-[url('@/assets/images/SouthAfrica.svg')] w-[24px] h-[24px] rounded-[50%] bg-contain"></div>
      )
  },
  {
      label: "Spain",
      code: '026',
      flag: (
      <div className="bg-[url('@/assets/images/Spain.4fe39d8a.svg')] w-[24px] h-[24px] rounded-[50%] bg-contain"></div>
      )
  },
  {
      label: "Sweden",
      code: '029',
      flag: (
      <div className="bg-[url('@/assets/images/Sweden.svg')] w-[24px] h-[24px] rounded-[50%] bg-contain"></div>
      )
  },
  {
      label: "Switzerland",
      code: '018',
      flag: (
      <div className="bg-[url('@/assets/images/Switzerland.svg')] w-[24px] h-[24px] rounded-[50%] bg-contain"></div>
      )
  },
  {
      label: "Taiwan",
      code: '053',
      flag: (
      <div className="bg-[url('@/assets/images/Taiwan.svg')] w-[24px] h-[24px] rounded-[50%] bg-contain"></div>
      )
  },
  {
      label: "Thailand",
      code: '068',
      flag: (
      <div className="bg-[url('@/assets/images/Thailand.svg')] w-[24px] h-[24px] rounded-[50%] bg-contain"></div>
      )
  },
  {
      label: "Turkey",
      code: '038',
      flag: (
      <div className="bg-[url('@/assets/images/Turkey.svg')] w-[24px] h-[24px] rounded-[50%] bg-contain"></div>
      )
  },
  {
      label: "Ukraine",
      code: '096',
      flag: (
      <div className="bg-[url('@/assets/images/Ukraine.svg')] w-[24px] h-[24px] rounded-[50%] bg-contain"></div>
      )
  },
  {
      label: "United Arab Emirates",
      code: '062',
      flag: (
      <div className="bg-[url('@/assets/images/UnitedArabEmirates.svg')] w-[24px] h-[24px] rounded-[50%] bg-contain"></div>
      )
  },
  {
      label: "United Kingdom",
      code: '010',
      flag: (
      <div className="bg-[url('@/assets/images/UnitedKingdom.svg')] w-[24px] h-[24px] rounded-[50%] bg-contain"></div>
      )
  },
  {
      label: "United States",
      code: '001',
      flag: (
      <div className="bg-[url('@/assets/images/United_States.28bbc756.svg')] w-[24px] h-[24px] rounded-[50%] bg-contain"></div>
      )
  },
  {
      label: "Vietnam",
      code: '067',
      flag: (
      <div className="bg-[url('@/assets/images/Vietnam.svg')] w-[24px] h-[24px] rounded-[50%] bg-contain"></div>
      )
  },
]